import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <span className="name">
        Inshorts clone made by -{" "}
        <a href="https://www.linkedin.com/in/suvadeep-maity-392a881a7/" target="__blank">
          Suvadeep Maity
        </a>
      </span>
    </div>
  );
};

export default Footer;